import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import ExclamationCircleRegularIcon from '../../shared/icons/exclamation-circle-regular-icon';

import styles from './package-includes-message.scss';

interface PackageIncludesMessageProps {
  isPrebuiltPackage?: boolean;
}

function PackageIncludesMessage(props: PackageIncludesMessageProps) {
  const { isPrebuiltPackage = false } = props;
  return (
    <div className={cn(styles['container'], 'package-includes-message')}>
      <Typography variant="H6" weight="black">
        {' '}
        Wheel & Tire Package
      </Typography>
      {isPrebuiltPackage && (
        <div>
          <ExclamationCircleRegularIcon className={styles['includes-icon']} />{' '}
          <span className={styles['includes-text']}>
            Package includes: 4 tires and 4 wheels
          </span>
        </div>
      )}
    </div>
  );
}

export default PackageIncludesMessage;
